import React from 'react';
type EyebrowProps = {
  children: React.ReactNode;
  align?: 'left' | 'center';
  tone?: 'default' | 'onDark';
};
export function Eyebrow({
  children,
  align = 'center',
  tone = 'default'
}: EyebrowProps) {
  return <p className={`mb-4 font-mono text-[0.7rem] font-semibold uppercase tracking-[0.16em] sm:text-xs ${tone === 'onDark' ? 'text-orangey-200' : 'text-orangey-700'} ${align === 'center' ? 'text-center' : 'text-left'}`} data-id="element-183" data-mp="33i9jnydpb0a8">
      {children}
    </p>;
}
type HeadingProps = {
  children: React.ReactNode;
  as?: 'h1' | 'h2' | 'h3';
  size?: 'xl' | 'lg' | 'md';
  className?: string;
};
const sizes = {
  xl: 'text-[2.5rem] leading-[1.05] sm:text-6xl lg:text-[4.25rem]',
  lg: 'text-3xl leading-[1.1] sm:text-5xl',
  md: 'text-[1.75rem] leading-[1.15] sm:text-4xl'
};
export function Heading({
  children,
  as = 'h2',
  size = 'md',
  className = ''
}: HeadingProps) {
  const Tag = as;
  return <Tag className={`font-display font-extrabold tracking-[-0.02em] text-ink-900 ${sizes[size]} ${className}`} data-id="element-184" data-mp="3r83y2kdo4wwl">
      {children}
    </Tag>;
}
type SectionProps = {
  children: React.ReactNode;
  id?: string;
  className?: string;
  ariaLabel?: string;
};
export function Section({
  children,
  id,
  className = '',
  ariaLabel
}: SectionProps) {
  return <section id={id} aria-label={ariaLabel} className={`px-5 py-10 sm:px-8 sm:py-[3.75rem] ${className}`} data-id="element-185" data-mp="19i2chgbyqaar">
      <div className="mx-auto w-full max-w-5xl" data-id="element-186" data-mp="buk8sjx5rydm">{children}</div>
    </section>;
}